import React from 'react';
import SlideLayout, { SlideTitle, SlideContent } from '../components/SlideLayout';
import { Settings, Shield, CheckCircle, AlertTriangle } from 'lucide-react';

const ConfigGenerationSlide = () => {
  return (
    <SlideLayout maxWidth="6xl">
      <SlideTitle 
        subtitle="Generate and validate network configurations using reasoning"
      >
        Configuration Generation & Validation
      </SlideTitle>
      
      <SlideContent>
        <div className="grid lg:grid-cols-2 gap-8">
          {/* Requirements */}
          <div>
            <h3 className="font-heading text-lg font-semibold text-foreground mb-4">Requirements Input</h3>
            
            <div className="slide-card font-mono text-sm">
              <div className="space-y-2 text-muted-foreground">
                <p><span className="text-primary">vendor:</span> <span className="text-accent">"Cisco IOS-XE"</span></p>
                <p><span className="text-primary">device_type:</span> <span className="text-accent">"access_switch"</span></p>
                <p><span className="text-primary">management_vlan:</span> <span className="text-chart-4">10</span></p>
                <p><span className="text-primary">data_vlans:</span> [<span className="text-chart-4">20, 30, 40</span>]</p>
                <p><span className="text-primary">security:</span></p>
                <p className="pl-4"><span className="text-secondary">port_security:</span> <span className="text-accent">true</span></p>
                <p className="pl-4"><span className="text-secondary">dhcp_snooping:</span> <span className="text-accent">true</span></p>
                <p className="pl-4"><span className="text-secondary">arp_inspection:</span> <span className="text-accent">true</span></p>
              </div>
            </div>
            
            {/* Validation result */}
            <div className="mt-4 slide-card">
              <h4 className="font-heading font-semibold text-foreground mb-3">Validation Result</h4>
              
              <div className="space-y-2">
                <div className="flex items-center justify-between p-2 rounded-lg bg-destructive/10">
                  <span className="text-sm text-muted-foreground">Passwords not encrypted</span>
                  <span className="text-xs font-medium text-destructive">CRITICAL</span>
                </div>
                <div className="flex items-center justify-between p-2 rounded-lg bg-destructive/10">
                  <span className="text-sm text-muted-foreground">SSH not configured</span>
                  <span className="text-xs font-medium text-destructive">CRITICAL</span>
                </div>
                <div className="flex items-center justify-between p-2 rounded-lg bg-chart-4/10">
                  <span className="text-sm text-muted-foreground">Weak passwords detected</span>
                  <span className="text-xs font-medium text-chart-4">WARNING</span>
                </div>
                <div className="flex items-center justify-between p-2 rounded-lg bg-accent/10">
                  <span className="text-sm text-muted-foreground">VLANs configured correctly</span>
                  <span className="text-xs font-medium text-accent">PASS</span>
                </div>
              </div>
              
              <div className="mt-4 flex items-center justify-between">
                <span className="text-sm text-muted-foreground">Score:</span>
                <span className="font-mono text-xl text-chart-4">61/100</span>
              </div>
            </div>
          </div>
          
          {/* Generated config */}
          <div>
            <h3 className="font-heading text-lg font-semibold text-foreground mb-4">Generated Configuration</h3>
            
            <div className="slide-card max-h-[500px] overflow-y-auto">
              <pre className="font-mono text-xs text-muted-foreground">
{`! VLANs
vlan 10
 name MANAGEMENT
vlan 20
 name DATA-DEPT-A

! Spanning Tree
spanning-tree mode rapid-pvst
spanning-tree portfast default

! DHCP Snooping
ip dhcp snooping
ip dhcp snooping vlan 20,30,40

! Uplink config (trunk)
interface range Gi1/0/1-2
 description UPLINK_TO_CORE
 switchport trunk encapsulation dot1q
 switchport mode trunk
 ip dhcp snooping trust

! Access ports
interface range Gi1/0/3-48
 description ACCESS_PORT
 switchport mode access
 switchport access vlan 20
 switchport port-security
 switchport port-security max 3
 switchport port-security violation restrict
 spanning-tree portfast`}
              </pre>
            </div>
            
            <div className="mt-4 p-3 rounded-lg bg-primary/10 border border-primary/20">
              <div className="flex items-start gap-2">
                <Settings className="w-4 h-4 text-primary mt-0.5" />
                <div className="text-sm">
                  <p className="text-foreground font-medium">Reasoning explains each choice</p>
                  <p className="text-muted-foreground text-xs mt-1">
                    Port security max 3: allows PC + phone + one other device
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SlideContent>
    </SlideLayout>
  );
};

export default ConfigGenerationSlide;
